import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import SupervisiUmumSvc from "@/services/SupervisiUmumService";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "supervisi-umum"
})
class SupervisiUmumModule extends VuexModule {
  sessions: any[] = [];
  currentSession: any = null;
  definitions: any[] = [];
  definitionsGrouped: any[] = [];
  dashboard: any = null;
  temuanTerbuka: any[] = [];
  loading = false;
  pagination: any = null;

  @Mutation SET_SESSIONS(val: any[]) {
    this.sessions = val;
  }

  @Mutation SET_CURRENT_SESSION(val: any) {
    this.currentSession = val;
  }

  @Mutation SET_DEFINITIONS(val: any[]) {
    this.definitions = val;
  }

  @Mutation SET_DEFINITIONS_GROUPED(val: any[]) {
    this.definitionsGrouped = val;
  }

  @Mutation SET_DASHBOARD(val: any) {
    this.dashboard = val;
  }

  @Mutation SET_TEMUAN_TERBUKA(val: any[]) {
    this.temuanTerbuka = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation SET_PAGINATION(val: any) {
    this.pagination = val;
  }

  @Action async loadDefinitions(params?: any) {
    this.SET_LOADING(true);
    try {
      const dt = await SupervisiUmumSvc.getDefinitions(params || { aktif: true });
      const resp = dt.data;
      this.SET_DEFINITIONS_GROUPED(resp.data || []);
      this.SET_DEFINITIONS(resp.flat || []);
    } catch {
      this.SET_DEFINITIONS([]);
      this.SET_DEFINITIONS_GROUPED([]);
    }
    this.SET_LOADING(false);
  }

  @Action async loadSessions(params?: any) {
    this.SET_LOADING(true);
    try {
      const dt = await SupervisiUmumSvc.getList(params);
      const resp = dt.data;
      this.SET_SESSIONS(resp.data?.data || []);
      this.SET_PAGINATION({
        current_page: resp.data?.current_page,
        last_page: resp.data?.last_page,
        total: resp.data?.total,
        per_page: resp.data?.per_page,
      });
    } catch {
      this.SET_SESSIONS([]);
    }
    this.SET_LOADING(false);
  }

  @Action async loadDetail(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await SupervisiUmumSvc.find(id);
      const { data } = dt.data;
      this.SET_CURRENT_SESSION(data || null);
    } catch {
      this.SET_CURRENT_SESSION(null);
    }
    this.SET_LOADING(false);
  }

  @Action async loadDashboard() {
    this.SET_LOADING(true);
    try {
      const dt = await SupervisiUmumSvc.getDashboard();
      const { data } = dt.data;
      this.SET_DASHBOARD(data || null);
    } catch {
      this.SET_DASHBOARD(null);
    }
    this.SET_LOADING(false);
  }

  @Action async loadTemuanTerbuka(params?: any) {
    this.SET_LOADING(true);
    try {
      const dt = await SupervisiUmumSvc.getTemuanTerbuka(params);
      const resp = dt.data;
      this.SET_TEMUAN_TERBUKA(resp.data?.data || []);
    } catch {
      this.SET_TEMUAN_TERBUKA([]);
    }
    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_SESSIONS([]);
    this.SET_CURRENT_SESSION(null);
    this.SET_DASHBOARD(null);
    this.SET_TEMUAN_TERBUKA([]);
  }
}

export const storeSupervisiUmum = getModule(SupervisiUmumModule);
